import React, { useState, useEffect } from 'react';
import { MULTI_TIME_ZONE } from '../../../../config';
import { addDevice, deviceconfigcrud, getAllZoneList, getDeviceTypeOnInterfaceId, getInterfaceSubTypeData, Getsitelist, updateDevice,generateRtspUrl } from '../../../../services/configurationServices';
import { useForm } from 'react-hook-form';
import { onNumberOnlyChange, onSpecialChangeOnly } from '../../EntityConfigUtils/entityConfigUtils';
import { useDeviceStage } from '../../../../CustomHooks/useDeviceStage';
import { useTimezone } from '../../../../CustomHooks/useTimezone';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { useDeviceType } from '../../../../CustomHooks/useDeviceType';
import { ConvertDateToUTC, isEmptyObject } from '../../../../utils/utils';
import Swal from 'sweetalert2';

let deviceObj = {
  ParentCameraID: 0,
  cameraName: "",
  privateIPAddress: "",
  SiteID: 0,
  userName: "",
  password: "",
  port: "",
  channelNumber: "",
  // "playbackChannelNumber": '',
  liveStreamTypeNumber: "",
  playbackStreamTypeNumber: "",
  rTSPURL: "",
  location: "",
  PanelMasterId: 0,
  CameraBrandId: 0,
  communicationPort: "",
  httpPort: "",
  isTranscoded: "",
  isPlaybackTranscoded: "",
  isTwoWayEnabledDevice: "",
  interfaceId: "",
  CCTVTypeID: 0,
  TimeZoneIdDevice: 0,
  isPTZ: "",
  isPlaybackUTC: "",
  identifierName: "",
  cameraDeviceId: 0,
  deviceStageTypeId: 0,
  SerialNo:""
};

const CCTVDeviceForm = ({
  formData = {},
  onFormDataChange,
  // errors = {},
  isEditMode = false,
  onCancel,
  interfaceData, // To set the selected interface data in it
  handleApplyFilters,
  filterValues
}) => {

  const [selectedDevice, setSelectedDevice] = useState(deviceObj);
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { isDirty, touchedFields },
  } = useForm({ defaultValue: { ...selectedDevice } });

  const [interfaceSubTypeData, setInterfaceSubTypeData] = useState([]);
  const [errors, setErrors] = useState({
    channelNumber: '',
    liveStreamType: '',
    playbackStreamType: '',
    rtspURL: '',
    deviceStage: '',
    deviceName: '',
    zoneName: '',
   SerialNo: ''
  });

  const [deviceTypeData, setDeviceTypeData] = useState([]);
  const [alertsChecked, setAlertChecked] = useState(false);
  const [healthMonitoringChecked, setHealthMonitoringChecked] = useState(false);
  const [camerasChecked, setCamerasChecked] = useState(false);
  const [videoBackupChecked, setVideoBackupChecked] = useState(false);
  const [parentIsEncoding, setParentIsEncoding] = useState(false);
  const [parentIsPlaybackEncoding, setParentIsPlaybackEncoding] = useState(false);
  const [parentIsEnablingTwoWayDevice, setParentIsEnablingTwoWayDevice] = useState(false);
  const [parentIsEnablingPTZ, setParentIsEnablingPTZ] = useState(false);
  const [parentIsEnablingUTCPlayback, setParentIsEnablingUTCPlayback] = useState(false);
  const [isChannelNumberEdited, setIsChannelNumberEdited] = useState(false)
  const [rtspValueChanged, setRtspValueChanged] = useState(false);
  const [isHooterEnabledInterface, setIsHooterEnabledInterface] = useState("");
  const [sites, setSites] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [unknownBrandUrl, setUnknownBrandUrl] = useState("");
  const [zoneOptions, setZoneOptions] = useState([]);
  const [cameraSearch, setCameraSearch] = useState("");
  const [editAssociate, setEditAssociate] = useState(false);
  const [cctvMasterList, setCCTVMasterList] = useState([]);
  const [cctvList, setCCTVList] = useState([]);
  const [cameraSelectAll, setCameraSelectAll] = useState(false);
  const [cameraCount, setCameraCount] = useState(0);
  
  const { deviceStage } = useDeviceStage();
  const { timezone } = useTimezone();
  const { deviceType } = useDeviceType()

  // Onvif devices should only allow Zone update and Associate Device changes.
  const isOnvifDevice = [true, 'true', 1, '1'].includes(formData?.IsOnvif) || [true, 'true', 1, '1'].includes(selectedDevice?.IsOnvif);

    useEffect(() => {
      const fetchZones = async () => {
        const siteId = filterValues?.Site?.[0]?.value || null;
        const customerId = filterValues?.Customer?.[0]?.value || null;
  
        if (siteId && customerId) {
          try {
            const response = await getAllZoneList({CustomerID: customerId, SiteID: siteId });
            console.log('Zone API Response:', response);
            
            if (response && response.Status === 'success' && response.Data) {
              const zoneOptions = response.Data.map((zone) => ({
                value: zone.ZoneID,
                label: zone.ZoneName,
              }));
              setZoneOptions(zoneOptions);
              console.log('Zone Options:', zoneOptions);
            } else {
              setZoneOptions([]);
            }
          } catch (error) {
            console.error('Error fetching zones:', error);
            setZoneOptions([]);
          }
        }
      };
  
      fetchZones();
    }, [filterValues]);

  const clearError = (field) => {
    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: ''
    }));
  };

  useEffect(() => {
    getSites();
  }, [])

  useEffect(() => {
    console.log("UseEffect formData", formData)
    // if (Object.keys(formData).length === 0) {
    //   console.log('UseEffect Adding New Device')
    // } else {
    //   let temp = {
    //     ...formData,
    //     ParentCameraID: formData?.DeviceId
    //   }
    //   setSelectedDevice(temp);
    //   getAssociateCCTVList(temp);
    //   setVideoBackupChecked(formData.CCTVRecordingBackup);
    //   setAlertChecked(formData.AlertMonitoring);
    //   setHealthMonitoringChecked(formData.HMMonitoring);
    //   setCamerasChecked(formData.CCTVMonitoring);
    // }
    handleFormDataChange(formData)
  }, [formData])

  const handleFormDataChange = (formData) => {
  if (isEmptyObject(formData)) {
    return;
  }

  const tempDevice = {
    ...formData,
    ParentCameraID: formData?.DeviceId
  };

  setSelectedDevice(tempDevice);
  getAssociateCCTVList(tempDevice);
  setVideoBackupChecked(formData.CCTVRecordingBackup);
  setAlertChecked(formData.AlertMonitoring);
  setHealthMonitoringChecked(formData.HMMonitoring);
  setCamerasChecked(formData.CCTVMonitoring);
};

  useEffect(() => {
    if (!interfaceData?.InterfacetypeId) return;
    getInterfaceSubType(interfaceData?.InterfacetypeId);
    getDeviceTypeByInterfaceId(interfaceData?.InterfacetypeId)
  }, [interfaceData])

  useEffect(() => {
    if (selectedDevice.ParentCameraID == 0) {
      let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
      setValue("cameraDeviceId", tempDeviceId?.DeviceTypeID)
    } else {
      setValue("cameraDeviceId", selectedDevice?.DeviceTypeID)
    }
  }, [interfaceData, deviceType, selectedDevice, deviceTypeData])

  useEffect(() => {
    if (selectedDevice && selectedDevice != null && interfaceSubTypeData.length != 0 && timezone.length != 0 && deviceType.length != 0) {
      let tempCameraBrandId = interfaceSubTypeData?.filter(item => {
        return item.InterfacesubtypeId == interfaceData.InterfacesubtypeId
      })
      let cameraBrandName = "";
      if (tempCameraBrandId != undefined) {
        cameraBrandName = tempCameraBrandId[0]?.Interfacesubtypename
      } else {
        cameraBrandName = "";
      }

      // setValue("SiteID", interfaceData?.SiteId)
      setValue("SiteID", selectedDevice?.ZoneID)
      setValue("cameraName", selectedDevice?.Name || selectedDevice?.DeviceName)
      setValue("privateIPAddress", interfaceData?.InterfaceIP)
      setValue("communicationPort", interfaceData.Communicationport)
      setValue("httpPort", interfaceData.InternetProtocolPort)
      setValue("userName", interfaceData.UserName)
      setValue("password", interfaceData?.Password)
      setValue("port", interfaceData?.InterfacePort)
      setValue("channelNumber", selectedDevice.ChannelNo)
      setValue("deviceStageTypeId", selectedDevice?.deviceStageTypeId ?? selectedDevice?.DeviceStageId)
      setValue("rTSPURL", selectedDevice?.RTSPCameraUrl && selectedDevice?.RTSPCameraUrl.replace("%40", "@"))
      setValue("location", selectedDevice?.Location)
      setValue("ParentCameraID", selectedDevice?.ParentDeviceID)
      setValue("CameraBrandId", interfaceData?.InterfacesubtypeId)
      setValue("CCTVTypeID", selectedDevice?.CCTVTypeID)
      setValue("TimeZoneIdDevice", interfaceData?.TimeZoneID)
      setValue("SerialNo", selectedDevice?.SerialNo)

      //New
      let liveSubType;
      let playbackSubType;
      let tempDeviceType
      if (interfaceData != null) {
        tempDeviceType = deviceType?.find((item) => item.DeviceTypeID == interfaceData?.EntityTypeID);
      }

      if (cameraBrandName == "Hikvision" || cameraBrandName == "Hikvision-Hybrid" || cameraBrandName == "STQC PRAMA") {
        liveSubType = selectedDevice.SubTypeLive == "01" ? "Main" : selectedDevice.SubTypeLive == "02" ? "Sub" : selectedDevice.SubTypeLive == "03" ? "Ter" : ""
        setValue("liveStreamTypeNumber", liveSubType)
        playbackSubType = selectedDevice.SubTypePlayback == "01" ? "Main" : selectedDevice.SubTypePlayback == "02" ? "Sub" : selectedDevice.SubTypePlayback == "03" ? "Ter" : ""
        setValue("playbackStreamTypeNumber", playbackSubType)
      } else if (cameraBrandName == "TP-Link") {
        liveSubType = selectedDevice.SubTypeLive == "1" ? "Main" : selectedDevice.SubTypeLive == "2" ? "Sub" : selectedDevice.SubTypeLive == '3' ? "Ter" : ""
        setValue("liveStreamTypeNumber", liveSubType)
        playbackSubType = selectedDevice.SubTypePlayback == "1" ? "Main" : selectedDevice.SubTypePlayback == "2" ? "Sub" : selectedDevice.SubTypePlayback == "3" ? "Ter" : ""
        setValue("playbackStreamTypeNumber", playbackSubType)
      }
      else {
        if (cameraBrandName == "UnV" && tempDeviceType?.DeviceType == "Camera") {
          liveSubType = selectedDevice.SubTypeLive == "1" ? "Main" : selectedDevice.SubTypeLive == "2" ? "Sub" : selectedDevice.SubTypeLive == '3' ? "Ter" : ""
          setValue("liveStreamTypeNumber", liveSubType)
          playbackSubType = selectedDevice.SubTypePlayback == "1" ? "Main" : selectedDevice.SubTypePlayback == "2" ? "Sub" : selectedDevice.SubTypePlayback == "3" ? "Ter" : ""
          setValue("playbackStreamTypeNumber", playbackSubType)
        } else {
          liveSubType = selectedDevice.SubTypeLive == "0" ? "Main" : selectedDevice.SubTypeLive == "1" ? "Sub" : selectedDevice.SubTypeLive == '2' ? "Ter" : ""
          setValue("liveStreamTypeNumber", liveSubType)
          playbackSubType = selectedDevice.SubTypePlayback == "0" ? "Main" : selectedDevice.SubTypePlayback == "1" ? "Sub" : selectedDevice.SubTypePlayback == "2" ? "Ter" : ""
          setValue("playbackStreamTypeNumber", playbackSubType)
        }
      }

      if (selectedDevice.IsTranscodingEnabled == "1") {
        setValue("isTranscoded", 1);
        setParentIsEncoding(true);
      } else {
        setValue("isTranscoded", 0);
        setParentIsEncoding(false);
      }

      if (selectedDevice.IsPlayBackTranscodingEnabled == "1") {
        setValue("isPlaybackTranscoded", 1);
        setParentIsPlaybackEncoding(true);
      } else {
        setValue("isPlaybackTranscoded", 0);
        setParentIsPlaybackEncoding(false);
      }

      if (selectedDevice.isTwoWayEnabled == "1") {
        setValue("isTwoWayEnabledDevice", 1);
        setParentIsEnablingTwoWayDevice(true);
      } else {
        setValue("isTwoWayEnabledDevice", 0);
        setParentIsEnablingTwoWayDevice(false);
      }

      if (selectedDevice.PTZ == "1") {
        setValue("isPTZ", 1);
        setParentIsEnablingPTZ(true)
      } else {
        setValue("isPTZ", 0);
        setParentIsEnablingPTZ(false);
      }

      if (selectedDevice.ISPlaybackUTC == "1") {
        setValue("isPlaybackUTC", 1);
        setParentIsEnablingUTCPlayback(true);
      } else {
        setValue("isPlaybackUTC", 0);
        setParentIsEnablingUTCPlayback(false);
      }

      // setValue("isTranscoded", selectedDevice.isTranscoded);
    }
  }, [selectedDevice, interfaceSubTypeData, deviceType, timezone]);

useEffect(() => {

  const generateLiveRTSP = async () => {

    try {

      // =========================================
      // REQUIRED FIELD VALIDATION
      // =========================================

      if (
        !watch("CameraBrandId") ||
        !watch("privateIPAddress") ||
        !watch("userName") ||
        !watch("password") ||
        !watch("port") ||
        !watch("channelNumber") ||
        !watch("liveStreamTypeNumber")
      ) {
        return;
      }

      // =========================================
      // GET CAMERA BRAND
      // =========================================

      const tempCameraBrand = interfaceSubTypeData?.find(
        item =>
          item.InterfacesubtypeId ==
          getValues("CameraBrandId")
      );

      const cameraBrandName =
        tempCameraBrand?.Interfacesubtypename;

      // =========================================
      // UNKNOWN BRAND HANDLING
      // =========================================

      if (cameraBrandName === "Unknown") {

        let link = interfaceData?.LiveRTSPURL || "";

        const replacements = {
          "[Username]": getValues("userName"),
          "[Password]": encodeURIComponent(
            getValues("password")
          ),
          "[IpAddress]": getValues("privateIPAddress"),
          "[Port]": getValues("port"),
          "[ChannelNo]": getValues("channelNumber"),
          "[LiveStreamType]":
            getValues("liveStreamTypeNumber")
        };

        for (const [placeholder, value] of Object.entries(
          replacements
        )) {

          link = link
            ?.split(placeholder)
            .join(value);
        }

        setUnknownBrandUrl(link);

        setValue("rTSPURL", link);

        clearError("rtspURL");

        return;
      }

      // =========================================
      // API PAYLOAD
      // =========================================

      const payload = {

        interfaceSubTypeID: Number(
          getValues("CameraBrandId")
        ),

        deviceTypeID: Number(
          interfaceData?.EntityTypeID
        ),

        username: getValues("userName"),

        password: getValues("password"),

        ip: getValues("privateIPAddress"),

        port: Number(
          getValues("port")
        ),

        channel: String(
          getValues("channelNumber")
        ),

        // Main / Sub / Third
        // Backend handles mapping
        live_stream:
          getValues("liveStreamTypeNumber"),

        mode: "live"
      };

      // =========================================
      // API CALL
      // =========================================

      const response =
        await generateRtspUrl(payload);

      // =========================================
      // SUCCESS
      // =========================================

      if (
        response?.Status === "success"
      ) {

        setValue(
          "rTSPURL",
          response?.Data?.rtspURL || ""
        );

        clearError("rtspURL");

      } else {

        setValue("rTSPURL", "");
      }

    } catch (error) {

      console.error(
        "Generate RTSP Error:",
        error
      );

      setValue("rTSPURL", "");
    }
  };

  generateLiveRTSP();

}, [

  watch("CameraBrandId"),
  watch("privateIPAddress"),
  watch("userName"),
  watch("password"),
  watch("port"),
  watch("channelNumber"),
  watch("liveStreamTypeNumber"),
  isChannelNumberEdited

]);

  const getDeviceTypeByInterfaceId = (id) => {
    getDeviceTypeOnInterfaceId(id)
      .then((res) => {
        if (res.Status == "success") {
          setDeviceTypeData(res.Data)
        } else {
          setDeviceTypeData([])
        }
      }).catch(err => console.log(err))
  }

  const getSites = async () => {
    try {
      const resp = await Getsitelist();
      if(resp?.Status === "success"){
        setSites(resp.Data);
      }else{
        setSites(null);
      }
    } catch (error) {
      console.error(error);
      setSites(null);
    }
  };
  console.log("interfaceDataParentDeviceID",selectedDevice)

  // const handleInputChange = (field, value) => {
  //   if (onFormDataChange) {
  //     onFormDataChange({ ...formData, [field]: value });
  //   }
  // };

  const OnSaveDevice = async (data, parentCameraID) => {

    const onvifMode = [true, 'true', 1, '1'].includes(selectedDevice?.IsOnvif) || [true, 'true', 1, '1'].includes(formData?.IsOnvif);
    const siteId = data.SiteID;

    if (onvifMode) {
      const newErrors = {
        channelNumber: '',
        liveStreamType: '',
        playbackStreamType: '',
        rtspURL: '',
        deviceStage: '',
        deviceName: '',
        zoneName: '',
        SerialNo: ''
      };
      if (siteId == undefined || siteId == 0 || siteId === "") {
        newErrors.zoneName = 'Please select zone!';
        setErrors(newErrors);
        return;
      }

      const user = JSON.parse(localStorage.getItem("user"));
      const updateOnvifDeviceObj = {
        DeviceId: selectedDevice.DeviceId,
        CameraId: selectedDevice.CameraId || selectedDevice.DeviceId,
        SiteId: siteId,
        InterfaceId: interfaceData?.InterfaceId,
        DeviceTypeID: selectedDevice.DeviceTypeID || interfaceData?.EntityTypeID || 0,
        OrganizationMasterID: user.OrganizationMasterID.toString(),
        CameraIp: selectedDevice.CameraIp || selectedDevice.privateIPAddress || "",
        TimeZoneID: selectedDevice.TimeZoneID || interfaceData?.TimeZoneID || 0,
        UserID: user.Id,
        ModifiedBy: user.Id,
        // in payload resend the existing values for all below fields except Zone and Associate Device, as Onvif update should only update these 2 fields and not change anything else.
        CameraPort: formData?.CameraPort,
        ChannelNo: formData?.ChannelNo,
        cctvHooterEnabledFlag: formData?.cctvHooterEnabledFlag,
        PlayBackChannelNum: formData?.PlayBackChannelNum,
        IsTranscodingEnabled: formData?.IsTranscodingEnabled,
        IsPlayBackTranscodingEnabled: formData?.IsPlayBackTranscodingEnabled,
        SubTypeLive: formData?.SubTypeLive,
        SubTypePlayback: formData?.SubTypePlayback,
        ISPlaybackUTC: formData?.ISPlaybackUTC,
        isTwoWayEnabled: formData?.isTwoWayEnabled,
        InternetProtocolPort: formData?.InternetProtocolPort,
        CamUser: formData?.CamUser,
        CamPassword: formData?.CamPassword,
        RTSPCameraUrl: formData?.RTSPCameraUrl,
        ParentDeviceID: formData?.ParentDeviceID,
        IsPtz: formData?.PTZ,
        Lat: 0,
        Long: 0,
        Communicationport: formData?.Communicationport,

      };
      // Use selectedDevice / interfaceData values for all remaining fields so Onvif update does not change any other device data.
      setIsSubmitting(true);
      updateDevice(updateOnvifDeviceObj).then((resp) => {
        if (resp) {
          if (resp.Status === "success") {
            setRtspValueChanged(false);
            SuccessToast(resp.Message);
            setIsSubmitting(false);
            handleApplyFilters();
          } else {
            setIsSubmitting(false);
            ErrorToast(resp.Message);
          }
        }
      });
      return;
    }

    let privateIPAddress = data.privateIPAddress;
    let cameraName = data.cameraName;
    let userName = data.userName;
    let password = data.password;
    let port = data.port;
    let channelNumber = data.channelNumber;
    let liveStreamTypeNumber = data.liveStreamTypeNumber;
    let playbackStreamTypeNumber = data.playbackStreamTypeNumber;
    let rtspURL = data.rTSPURL;
    let CameraBrandId = data.CameraBrandId;
    let communicationPort = data.communicationPort;
    let httpPort = data.httpPort;
    let timeZoneIdDevice = parseInt(data.TimeZoneIdDevice);
    let SerialNo = data.SerialNo
    // let isPTZ = data.isPTZ;
    // let isPlaybackUTC = data.isPlaybackUTC;
    // let identifierName = data.identifierName;
    let cameraDeviceTypeId = data?.cameraDeviceId || 6
    let user = JSON.parse(localStorage.getItem("user"));
    let deviceStageId = parseInt(data.deviceStageTypeId);
    let EnableTranscoding;
    if (parentIsEncoding) {
      EnableTranscoding = 1;
    } else {
      EnableTranscoding = 0;
    }

    let EnablePlaybackTranscoding;
    if (parentIsPlaybackEncoding) {
      EnablePlaybackTranscoding = 1;
    } else {
      EnablePlaybackTranscoding = 0;
    }

    let Enabletwowaydevice;
    if (parentIsEnablingTwoWayDevice) {
      Enabletwowaydevice = 1;
    } else {
      Enabletwowaydevice = 0;
    }

    let EnablePTZ;
    if (parentIsEnablingPTZ) {
      EnablePTZ = 1;
    } else {
      EnablePTZ = 0;
    }

    let EnablePlaybackUTC;
    if (parentIsEnablingUTCPlayback) {
      EnablePlaybackUTC = 1;
    } else {
      EnablePlaybackUTC = 0;
    }
    let CCTVTypeID = data.CCTVTypeID;
    let deviceTypeName = deviceType.find((item) => item.DeviceTypeID == interfaceData?.EntityTypeID);

    let tempCameraBrandId = interfaceSubTypeData?.filter((item) => {
      return item.InterfacesubtypeId == CameraBrandId;
    });
    let cameraBrandName = tempCameraBrandId[0].Interfacesubtypename;
    //New
    if (
      cameraBrandName == "Hikvision" ||
      cameraBrandName == "Hikvision-Hybrid" || 
      cameraBrandName == "STQC PRAMA"
    ) {
      liveStreamTypeNumber =
        liveStreamTypeNumber == "Main"
          ? "01"
          : liveStreamTypeNumber == "Sub"
            ? "02"
            : liveStreamTypeNumber == "Ter"
              ? "03"
              : "";
      playbackStreamTypeNumber =
        playbackStreamTypeNumber == "Main"
          ? "01"
          : playbackStreamTypeNumber == "Sub"
            ? "02"
            : playbackStreamTypeNumber == "Ter"
              ? "03"
              : "";
    } else if (cameraBrandName == "TP-Link") {
      liveStreamTypeNumber = liveStreamTypeNumber == "Main" ? "1" : liveStreamTypeNumber == "Sub" ? "2" : liveStreamTypeNumber == "Ter" ? "3" : ""
      playbackStreamTypeNumber = playbackStreamTypeNumber == "Main" ? "1" : playbackStreamTypeNumber == "Sub" ? "2" : playbackStreamTypeNumber == "Ter" ? "3" : ""
    } else {
      liveStreamTypeNumber =
        liveStreamTypeNumber == "Main"
          ? "0"
          : liveStreamTypeNumber == "Sub"
            ? "1"
            : liveStreamTypeNumber == "Ter"
              ? "2"
              : "";
      playbackStreamTypeNumber =
        playbackStreamTypeNumber == "Main"
          ? "0"
          : playbackStreamTypeNumber == "Sub"
            ? "1"
            : playbackStreamTypeNumber == "Ter"
              ? "2"
              : "";
    }

    let validationError = "";
    const newErrors = {
      channelNumber: '',
      liveStreamType: '',
      playbackStreamType: '',
      rtspURL: '',
      deviceStage: '',
      deviceName: '',
      zoneName: '',
      SerialNo:''
    };
    if (
      channelNumber === undefined ||
      channelNumber === null ||
      channelNumber === "" ||
      channelNumber.toString().trim() === ""
    ) {
      validationError += "channel number-Please enter channel number!,";
      newErrors.channelNumber = 'Please enter channel number!';
    }

    if (
      liveStreamTypeNumber === undefined ||
      liveStreamTypeNumber === null ||
      liveStreamTypeNumber === ""
    ) {
      validationError +=
        "live stream type-Please enter live stream type number!,";
      newErrors.liveStreamType = 'Please enter live stream type number!';
    }

    if (
      playbackStreamTypeNumber === undefined ||
      playbackStreamTypeNumber === null ||
      playbackStreamTypeNumber === ""
    ) {
      validationError +=
        "playback stream type-Please enter playback stream type number!,";
      newErrors.playbackStreamType = 'Please enter playback stream type number!';
    }

    if (
      rtspURL === undefined ||
      rtspURL === null ||
      rtspURL == "" ||
      rtspURL.trim() === "" ||
      rtspURL.includes("undefined")
    ) {
      validationError += "rtsp URL-RTSP url cannot be empty!,";
      newErrors.rtspURL = 'RTSP url cannot be empty!';
    }
    if (
      cameraName === undefined ||
      cameraName === null ||
      cameraName === "" ||
      cameraName.trim() === ""
    ) {
      validationError += "device name-Please enter device name!,";
      newErrors.deviceName = 'Please enter device name!';
    }
    
    // if (
    //   SerialNo === undefined ||
    //   SerialNo === null ||
    //   SerialNo === "" ||
    //   SerialNo.trim() === ""
    // ) {
    //   validationError += "serial no-Please enter serial no!,";
    //   newErrors.SerialNo = 'Please enter serial no!';
    // }

    if(siteId == undefined || siteId == 0 || siteId == ""){
      validationError += "site-Please select zone!,";
      newErrors.zoneName = 'Please select zone!';
    }

    if (deviceStageId == undefined || deviceStageId == 0) {
      validationError += "device stageid-Please select device stage type!,";
      newErrors.deviceStage = 'Please select device stage type!';
    }
    setErrors(newErrors);
    if (validationError != "") {
      return;
    }
    if (parentCameraID == 0) {
      let addAllDeviceObj = {
        ParentDeviceID: interfaceData?.ParentDeviceId, //Sending the camera id of the zero channel
        ExternalId: "",
        Description: "",
        Metadata: "",
        DeviceTypeID: cameraDeviceTypeId, //This is different compared to MH, right now if camera then 6
        Lat: 0,
        Long: 0,
        Altitude: 0,
        SiteId: siteId,
        InterfaceId: interfaceData.InterfaceId,
        Name: cameraName?.toString().trim(),
        InternetProtocolPort: httpPort,
        isTwoWayEnabled: Enabletwowaydevice,
        alarmpanelHooterEnabledFlag: false, //Doubt
        Communicationport: communicationPort,
        OrganizationMasterID: user.OrganizationMasterID.toString(),
        TimeZoneID: timeZoneIdDevice,
        CreatedOn: "",
        ModifiedON: "",
        CreatedBy: user.Id,
        ModifiedBy: "",
        UpdatedateTime: "",
        CameraId: 0,
        CameraGuid: "",
        // IsPtz: isPTZ,
        IsPtz: EnablePTZ,
        CameraIp: privateIPAddress,
        CameraPort: port,
        CamUser: userName,
        CamPassword: password,
        ChannelNo: channelNumber,
        RTSPCameraUrl: rtspURL,
        CCTVTypeID: cameraDeviceTypeId,
        cctvHooterEnabledFlag: interfaceData?.isHooterEnabled,
        PlayBackChannelNum: 1, //Doubt
        IsPlayBackTranscodingEnabled: EnablePlaybackTranscoding,
        IsTranscodingEnabled: EnableTranscoding,
        SubTypeLive: liveStreamTypeNumber,
        SubTypePlayback: playbackStreamTypeNumber,
        // ISPlaybackUTC: isPlaybackUTC,
        ISPlaybackUTC: EnablePlaybackUTC,
        HLSStreamingURL: null,
        DeviceStageId: deviceStageId,
        MonitoringService: camerasChecked ? 1 : 0,
        HMService: healthMonitoringChecked ? 1 : 0,
        AlertService: alertsChecked ? 1 : 0,
        RecordingBackupService: videoBackupChecked ? 1 : 0,
        SerialNo: SerialNo?.toString().trim(),
        UserID: user.Id
      };
      setIsSubmitting(true);
      addDevice(addAllDeviceObj).then((resp) => {
        if (resp && resp.Status === "success") {
          let tempDeviceId = deviceType.find((item) => item.DeviceType == "Camera")
          let deviceObject = {
            ParentCameraID: 0,
            cameraName: "",
            privateIPAddress: interfaceData.InterfaceIP,
            SiteID: interfaceData.SiteId || interfaceData.siteid,
            userName: interfaceData.UserName,
            password: interfaceData.Password,
            port: interfaceData.InterfacePort,
            channelNumber: "",
            // "playbackChannelNumber": '',
            liveStreamTypeNumber: "",
            playbackStreamTypeNumber: "",
            rTSPURL: "",
            location: "",
            PanelMasterId: 0,
            CameraBrandId: 0,
            communicationPort: interfaceData.communicationPortInterface || interfaceData.Communicationport,
            httpPort: interfaceData.httpPortInterface || interfaceData.InternetProtocolPort,
            isTranscoded: 0,
            isPlaybackTranscoded: 0,
            isTwoWayEnabledDevice: Enabletwowaydevice,
            CCTVTypeID: interfaceData.EntityTypeID,
            TimeZoneIdDevice:
              interfaceData.TimeZoneID || interfaceData.TimeZoneId,
            isPTZ: 0,
            isPlaybackUTC: 0,
            identifierName: "",
            cameraDeviceId: tempDeviceId?.DeviceTypeID || 6,
            deviceStageTypeId: 0,
            SerialNo:'',
            UserID: user.Id
          };
          setSelectedDevice(deviceObject);
          setVideoBackupChecked(false);
          setAlertChecked(false);
          setHealthMonitoringChecked(false);
          setCamerasChecked(false);
          setRtspValueChanged(false);
          SuccessToast(resp.Message);
          setIsSubmitting(false);
          handleApplyFilters()
        } else {
          setIsSubmitting(false);
          ErrorToast(resp.Message);
        }
      });
    }
    else if (parentCameraID && parentCameraID != 0 && parentCameraID != undefined) {
      let tempParentDeviceId = interfaceData.ParentDeviceId == selectedDevice.DeviceId ? null : interfaceData.ParentDeviceId
      let updateAllDeviceObj = {
        DeviceId: selectedDevice.DeviceId,
        ParentDeviceID: tempParentDeviceId,
        ExternalId: "",
        Description: "",
        Metadata: "",
        DeviceTypeID: cameraDeviceTypeId, //This is different compared to MH, right now if camera then 6
        Lat: 0,
        Long: 0,
        Altitude: 0,
        SiteId: siteId,
        InterfaceId: interfaceData.InterfaceId,
        Name: cameraName?.toString().trim(),
        InternetProtocolPort: httpPort,
        isTwoWayEnabled: Enabletwowaydevice,
        alarmpanelHooterEnabledFlag: false, //Doubt
        Communicationport: communicationPort,
        OrganizationMasterID: user.OrganizationMasterID.toString(),
        TimeZoneID: timeZoneIdDevice,
        CreatedOn: "",
        ModifiedON: "",
        CreatedBy: "",
        ModifiedBy: user.Id,
        UpdatedateTime: "",
        CameraId: selectedDevice.DeviceId,
        CameraGuid: "",
        IsPtz: EnablePTZ,
        CameraIp: privateIPAddress,
        CameraPort: port,
        CamUser: userName,
        CamPassword: password,
        ChannelNo: channelNumber,
        RTSPCameraUrl: rtspURL,
        CCTVTypeID: cameraDeviceTypeId,
        cctvHooterEnabledFlag: interfaceData?.isHooterEnabled,
        PlayBackChannelNum: 1, //Doubt
        IsPlayBackTranscodingEnabled: EnablePlaybackTranscoding,
        IsTranscodingEnabled: EnableTranscoding,
        SubTypeLive: liveStreamTypeNumber,
        SubTypePlayback: playbackStreamTypeNumber,
        ISPlaybackUTC: EnablePlaybackUTC,
        HLSStreamingURL: null,
        DeviceStageId: deviceStageId,
        MonitoringService: camerasChecked ? 1 : 0,
        HMService: healthMonitoringChecked ? 1 : 0,
        AlertService: alertsChecked ? 1 : 0,
        RecordingBackupService: videoBackupChecked ? 1 : 0,
        SerialNo: SerialNo?.toString().trim(),
        UserID: user.Id
      };
      setIsSubmitting(true);
      updateDevice(updateAllDeviceObj).then((resp) => {
        if (resp) {
          if (resp.Status === "success") {
            setRtspValueChanged(false);
            SuccessToast(resp.Message);
            setIsSubmitting(false);
            handleApplyFilters()
            // if(deviceStageId === 1){
            //   onCloseAlertOnDeviceId(selectedDevice.CameraId);
            // }
          } else {
            setIsSubmitting(false);
            ErrorToast(resp.Message);
          }
        }
      });
    }
  };

  const getInterfaceSubType = (interfaceType) => {
    try {
      let obj = {
        type: "interfacesubtypemaster",
        parameters: {
          InterfacetypeId: interfaceType,
        },
      };
      if (interfaceType != undefined) {
        getInterfaceSubTypeData(obj).then((resp) => {
          if (resp != undefined) {
            if (resp.Status == "success") {
              setInterfaceSubTypeData(resp.Data);
            } else {
              setInterfaceSubTypeData(null);
            }
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAssociateCCTVList = (devicedt) => {
      var obj = {
        action: "getAssociatedCamerasList",
        deviceId: devicedt.DeviceId,
        userUniqueId: localStorage.getItem('UserID'),
        clientId: devicedt.clientId,
        siteId: devicedt.SiteID
      };
      deviceconfigcrud(obj)
        .then((res) => {
          if (res.status == "Ok"  || res && res.Status === "success") {
            let isAllSelected = true;
            let custTemp = res.Data.map((item, index) => {
              let obj;
              if (item.isSelected == false) {
                isAllSelected = false;
                obj = {
                  ...item,
                  isChecked: false
                }
              } else {
                obj = {
                  ...item,
                  isChecked: true
                }
              }
              return obj;
            })
            setCCTVList(custTemp);
            setCCTVMasterList(custTemp);
            setCameraCount(custTemp.length);
            if (isAllSelected) {
              setCameraSelectAll(true)
            } else {
              setCameraSelectAll(false)
            }
          }
        })
    }

  const cctvCheckHandler = (e, id) => {
    let arr = cctvList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let masterCustomer = cctvMasterList.map((item) => {
      let obj;
      if (item.deviceId == id) {
        obj = {
          ...item,
          isChecked: !item.isChecked
        }
      } else {
        obj = {
          ...item
        }
      }
      return obj;
    })

    let customerArr = arr.filter((item) => item.isChecked).map((i) => i.deviceId);
    let clientIds = customerArr.join(',');
    setCCTVMasterList(masterCustomer);
    setCCTVList(arr);

  }

  const searchCCTVCameraHandler = (e, type) => {
    let searchText = e.target.value;
    if (type == "Camera") {
      setCameraSearch(searchText);
      let arr = cctvMasterList.filter((item) => item.cameraName.toLowerCase().includes(searchText.toLowerCase()));
      let isChecked = true;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].isChecked == true) {
          continue;
        } else {
          isChecked = false;
          break;
        }
      }
      setCameraSelectAll(isChecked);
      setCCTVList(arr);
      setCameraCount(arr.length);
    }
  }

  const cancelCCTVAssociation = () => {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to cancel the changes made?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#027aaa',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if(result.isConfirmed){
          setCameraSearch("")
          setEditAssociate(false);
          getAssociateCCTVList(selectedDevice)
        }
      })
    }

  const associatetCCTV = (selectedDevice) => {
      var createdtime = ConvertDateToUTC(new Date())
      let userid = localStorage.getItem('UserID')
      let selectedItems = cctvMasterList.filter(j => j.isChecked).map((i) => i.deviceId);
      if(selectedItems.length > 4){
        ErrorToast(`Maximum only 4 cameras can be associated, you have associated ${selectedItems.length} cameras`)
          return;
      }
      var obj = {
        action: "associateCamerasToSensor",
        associatedCameraIds: selectedItems,
        deviceId: selectedDevice.DeviceId,
        createdBy: userid,
        createdOn: createdtime,
        userUniqueId: null,
      };
      deviceconfigcrud(obj).then((resp) => {
        if (resp && resp.status === "Ok" || resp && resp.Status === "success") {
          SuccessToast(resp.Message)
          setEditAssociate(false);
        }
        else {
         // setEditAssociate(true);
          ErrorToast('Error occurred while associating the device!')
        }
      })
    }

  return (
    <>
      <div className="site-form">
        <h6 className="form-section-title">CCTV Device Configuration</h6>
      </div>

      <div className='DeviceFormScroll'>
        <div className="site-form">
          {!isOnvifDevice && (
            <>
              <div className="inputMainContainer w40dot75rem">
            <div className="inputTypeLabelContainer">
              <label className="formFieldLabels">Brand Name</label>
              <select
                {...register("CameraBrandId")}
                disabled={true}
                className="inputType ArrowSelectClass"
                onChange={(e) => {
                  setValue("CameraBrandId", e.target.value);
                }}
                placeholder="Select Brand Name"
              >
                <option key="0" disabled={false} value="0">Select Brand Name*</option>
                {interfaceSubTypeData &&
                  interfaceSubTypeData.map((val) => (
                    <option
                      value={val.InterfacesubtypeId}
                      key={val.InterfacesubtypeId}
                      id={val.InterfacesubtypeId}
                    >
                      {val.Interfacesubtypename}
                    </option>
                  ))}
              </select>
              {errors.brandName && <p className="Error_P"><span>{errors.brandName}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>IP Address</label>
              <input
                {...register("privateIPAddress")}
                className="inputType"
                disabled={true}
                placeholder="IP Address* e.g. 192.168.0.54"
              />
              {errors.ipAddress && <p className="Error_P"><span>{errors.ipAddress}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Communication Port</label>
              <input
                className="inputType"
                {...register("communicationPort")}
                disabled={true}
                placeholder="Enter Communication Port* e.g. 8080"
                onKeyPress={(e) => {
                  onNumberOnlyChange(e);
                  //   setCommunicationPortError('')
                }}
              />
              {errors.communicationPort && <p className="Error_P"><span>{errors.communicationPort}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>HTTP Port</label>
              <input
                {...register("httpPort")}
                disabled={true}
                className="inputType"
                placeholder="Enter HTTP Port* e.g. 443"
                onKeyPress={(e) => {
                  onNumberOnlyChange(e);
                }}
              />
              {errors.httpPort && <p className="Error_P"><span>{errors.httpPort}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>User Name</label>
              <input
                {...register("userName")}
                className="inputType"
                disabled={true}
                placeholder="User Name* e.g. Admin"
              />
              {errors.username && <p className="Error_P"><span>{errors.username}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Password</label>
              <input
                {...register("password")}
                className="inputType"
                disabled={true}
                type="password"
                placeholder="Password* e.g. Abc@123"
              />
              {errors.password && <p className="Error_P"><span>{errors.password}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>RTSP Port</label>
              <input
                {...register("port")}
                className="inputType"
                onKeyPress={onNumberOnlyChange}
                disabled={true}
                placeholder="RTSP Port* e.g. 554"
              />
              {errors.rtspPort && <p className="Error_P"><span>{errors.rtspPort}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Channel Number*</label>
              <input
                {...register("channelNumber")}
                className="inputType"
                onKeyPress={(e) => {
                  setIsChannelNumberEdited(true)
                  onNumberOnlyChange(e)
                  clearError('channelNumber')
                }}
                placeholder="Channel Number*"
              />
              {errors.channelNumber && <p className="Error_P" style={{ float: "left" }}><span>{errors.channelNumber}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Live Stream Type*</label>
              <select
                {...register("liveStreamTypeNumber")}
                className="inputType ArrowSelectClass"
                onChange={(e) => {
                  setValue('liveStreamTypeNumber', e.target.value)
                  clearError('liveStreamType')
                }}
              >
                <option value="">Select Live Stream Type*</option>
                <option value="Main">Main</option>
                <option value="Sub">Sub</option>
                <option value="Ter">Ter</option>
              </select>
              {errors.liveStreamType && <p className="Error_P" style={{ float: "left" }}><span>{errors.liveStreamType}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Playback Stream Type*</label>
              <select
                {...register("playbackStreamTypeNumber")}
                className="inputType ArrowSelectClass"
                placeholder="Stream type (Playback)*"
                onChange={(e) => {
                  setValue('playbackStreamTypeNumber', e.target.value)
                  clearError('playbackStreamType')
                }}
              >
                <option value="">Select Playback Stream Type*</option>
                <option value="Main">Main</option>
                <option value="Sub">Sub</option>
                <option value="Ter">Ter</option>
              </select>
              {errors.playbackStreamType && <p className="Error_P" style={{ float: "left" }}><span>{errors.playbackStreamType}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>RTSP URL*</label>
              <input
                {...register("rTSPURL")}
                disabled={true}
                className="inputType"
                onChange={() => {
                  setRtspValueChanged(true)
                  clearError('rtspURL')
                }}
                placeholder="RTSP URL* e.g. rtsp://Admin:Abc@123@192.168.0.58:554/Streaming/Channels/1"
              />
              {errors.rtspURL && <p className="Error_P" style={{ float: "left" }}><span>{errors.rtspURL}</span></p>}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Device Name*</label>
              <input
                {...register("cameraName")}
                className="inputType"
                placeholder="Enter Device Name* e.g. Lobby Camera"
                onKeyPress={(e) => {
                  onSpecialChangeOnly(e);
                  clearError('deviceName')
                }}
                onChange={() => { clearError('deviceName') }}
              />
              {errors.deviceName && <p className="Error_P" style={{ float: "left" }}><span>{errors.deviceName}</span></p>}
            </div>
          </div>
          {/* End non-Onvif fields. Zone remains visible for Onvif devices. */}
          </>
          )}
          {/* <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Branch Name</label>
              <select
                {...register("SiteID")}
                disabled={true}
                className="inputType ArrowSelectClass"
                onChange={(e) => setValue("SiteID", e.target.value)}
              >
                <option key="0" disabled={false} value="0">Select Branch*</option>
                {sites &&
                  sites.map((site) => (
                    <option value={site.SiteID} key={site.SiteID}>
                      {site.SiteName}
                    </option>
                  ))}
              </select>
              {errors.branchName && <p className="Error_P"><span>{errors.branchName}</span></p>}
            </div>
          </div> */}

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Zone*</label>
              <select
                {...register("SiteID")}
                className="inputType ArrowSelectClass"
                onChange={(e) => clearError('zoneName')}
              >
                <option value="">Select Zone*</option>
                {zoneOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {(errors.zoneName) && (
                <p className="Error_P" style={{ float: "left" }}><span> {errors.zoneName} </span></p>
              )}
            </div>
          </div>

          {!isOnvifDevice && (
          <>
          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Device Type</label>
              <select
                {...register("cameraDeviceId")}
                className="inputType ArrowSelectClass"
                placeholder="Device Type*"
                disabled={true}
                onChange={(e) =>
                  setValue("cameraDeviceId", e.target.value)
                }
              >
                <option key="0" disabled={false} value="0" id="0">Device Type*</option>
                {deviceTypeData && deviceTypeData.map((item) => (
                  <option value={item.DeviceTypeID} key={item.DeviceTypeID}>
                    {item.DeviceType}
                  </option>
                ))}
              </select>
              {errors.deviceType && <p className="Error_P"><span>{errors.deviceType}</span></p>}
            </div>
          </div>

          {MULTI_TIME_ZONE && (
            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Timezone</label>
                <select
                  {...register("TimeZoneIdDevice")}
                  className="inputType ArrowSelectClass"
                  placeholder="Select timezone*"
                  disabled={true}
                  // defaultValue={selectedDevice.TimeZoneIdDevice}
                  onChange={(e) =>
                    setValue("TimeZoneIdDevice", e.target.value)
                  }
                >
                  <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                  {timezone &&
                    timezone.map((val) => (
                      <option
                        value={val.TimeZoneId} key={val.TimeZoneId}
                        id={val.Abbreviation}>
                        {val.Abbreviation}-({val.Fullname})
                      </option>
                    ))}
                </select>
                {errors.timezone && <p className="Error_P"><span>{errors.timezone}</span></p>}
              </div>
            </div>
          )}

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Serial No</label>
              <input
                {...register("SerialNo")}
                className="inputType"
                placeholder="Enter Serial No e.g. MH78UY"
                disabled={selectedDevice?.ParentDeviceID === null ? true : false}
                onKeyPress={(e) => {
                  onSpecialChangeOnly(e);
                  //clearError('SerialNo')
                }}
                // onChange={() => { clearError('SerialNo') }}
              />
              {/* {errors.SerialNo && <p className="Error_P" style={{ float: "left" }}><span>{errors.SerialNo}</span></p>} */}
            </div>
          </div>

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Enable Transcoding</label>
              <div className='mt-1 signTypeCheckboxLabels'>
                <div className="SiteTextBox SiteNameText mt-0">
                  <div className="onlyforEnableCheckbox ml-0">
                    <input
                      className="checkbox_custom"
                      type="checkbox"
                      {...register("isTranscoded")}
                      onChange={(e) => {
                        setValue("isTranscoded", Number(e.target.checked))
                        setParentIsEncoding(e.target.checked);
                      }}
                      defaultValue={Number(selectedDevice.isTranscoded)}
                    />
                    <label className="mb-0"
                      onClick={() => {
                        getValues("isTranscoded")
                        if (parentIsEncoding) {
                          setValue("isTranscoded", 0)
                          setParentIsEncoding(false);
                        } else {
                          setValue("isTranscoded", 1)
                          setParentIsEncoding(true);
                        }
                      }}
                    >
                      Live Enable Transcoding to H.264 <sup>(Optional)</sup>
                    </label>
                  </div>
                </div>

                <div className="SiteTextBox SiteNameText mt-0">
                  <div className="onlyforEnableCheckbox">
                    <input
                      className="checkbox_custom"
                      type="checkbox"
                      {...register("isPlaybackTranscoded")}
                      onChange={(e) => {
                        setValue("isPlaybackTranscoded", Number(e.target.checked))
                        setParentIsPlaybackEncoding(e.target.checked);
                      }}
                      defaultValue={Number(selectedDevice.isPlaybackTranscoded)}
                    />
                    <label className="mb-0"
                      onClick={() => {
                        getValues("isPlaybackTranscoded")
                        if (parentIsPlaybackEncoding) {
                          setValue("isPlaybackTranscoded", 0)
                          setParentIsPlaybackEncoding(false);
                        } else {
                          setValue("isPlaybackTranscoded", 1)
                          setParentIsPlaybackEncoding(true);
                        }
                      }}
                    >
                      Playback Enable Transcoding to H.264 <sup>(Optional)</sup>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {
            (interfaceData?.isTwoWayEnabled || interfaceData?.isTwoWayEnabled == '1') &&
            <div className="inputMainContainer w40dot75rem mt35">
              <div className="inputTypeLabelContainer">
                <label className='formFieldLabels'>Enable Two Way Communication</label>
                <div className="onlyforEnableCheckbox">
                  <input
                    className="checkbox_custom"
                    type="checkbox"
                    {...register("isTwoWayEnabledDevice")}
                    onChange={(e) => {
                      setValue("isTwoWayEnabledDevice", Number(e.target.checked))
                      setParentIsEnablingTwoWayDevice(e.target.checked);
                    }}
                    defaultValue={Number(selectedDevice.isTwoWayEnabled)}
                  />
                  <label className="mb-0"
                    onClick={() => {
                      getValues("isTwoWayEnabledDevice")
                      if (parentIsEnablingTwoWayDevice) {
                        setValue("isTwoWayEnabledDevice", 0)
                        setParentIsEnablingTwoWayDevice(false);
                      } else {
                        setValue("isTwoWayEnabledDevice", 1)
                        setParentIsEnablingTwoWayDevice(true);
                      }
                    }}
                  >
                    Enable Two Way Communication
                  </label>
                </div>
              </div>
            </div>
          }

          <div className="inputMainContainer w40dot75rem mt35">
            <div className="inputTypeLabelContainer">
              <label className='formFieldLabels'>Enable PTZ</label>
              <div className="onlyforEnableCheckbox">
                <input
                  className="checkbox_custom"
                  type="checkbox"
                  {...register("isPTZ")}
                  onChange={(e) => {
                    setValue("isPTZ", Number(e.target.checked))
                    setParentIsEnablingPTZ(e.target.checked)
                    // setParentIsEnablingTwoWayDevice(e.target.checked);
                  }}
                  defaultValue={Number(selectedDevice.PTZ)}
                />
                <label className="mb-0"
                  onClick={() => {
                    getValues("isPTZ")
                    if (parentIsEnablingPTZ) {
                      setValue("isPTZ", 0)
                      setParentIsEnablingPTZ(false);
                      // setParentIsEnablingTwoWayDevice(false);
                    } else {
                      setValue("isPTZ", 1)
                      setParentIsEnablingPTZ(true);
                      // setParentIsEnablingTwoWayDevice(true);
                    }
                  }}
                >
                  Enable PTZ
                </label>
              </div>
            </div>
          </div>

          {MULTI_TIME_ZONE && (
            <>
              <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                  <label className='formFieldLabels'>Enable Playback in UTC</label>
                  <div className="onlyforEnableCheckbox">
                    <input
                      className="checkbox_custom"
                      type="checkbox"
                      {...register("isPlaybackUTC")}
                      onChange={(e) => {
                        setValue("isPlaybackUTC", Number(e.target.checked))
                        setParentIsEnablingUTCPlayback(e.target.checked);
                      }}
                      defaultValue={Number(selectedDevice.isPlaybackUTC)}

                    />
                    <label className="mb-0"
                      onClick={() => {
                        getValues("isPlaybackUTC")
                        if (parentIsEnablingUTCPlayback) {
                          setValue("isPlaybackUTC", 0)
                          setParentIsEnablingUTCPlayback(false);
                          // setParentIsEnablingTwoWayDevice(false);
                        } else {
                          setValue("isPlaybackUTC", 1)
                          setParentIsEnablingUTCPlayback(true);
                          // setParentIsEnablingTwoWayDevice(true);
                        }
                      }}
                    >
                      Enable Playback in UTC
                    </label>
                  </div>
                </div>
              </div>

              <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                  <label className='formFieldLabels'>Device Stage*</label>
                  <select
                    {...register("deviceStageTypeId")}
                    className="inputType ArrowSelectClass"
                    placeholder="Device stage"
                    onChange={(e) => {
                      setValue('deviceStageTypeId', e.target.value)
                      clearError('deviceStage')
                    }}

                  >
                    <option key="0" value="0" id="0">Select Device stage*</option>
                    {deviceStage &&
                      deviceStage.map((val) => (
                        <option
                          value={val.StageID} key={val.StageID}
                          id={val.StageID}>
                          {val.StageName}
                        </option>
                      ))}
                  </select>
                  {errors.deviceStage && <p className="Error_P" style={{ float: "left" }}><span>{errors.deviceStage}</span></p>}
                </div>
              </div>

              <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                  <label className='formFieldLabels'>License Services</label>
                  <div className='mt-1 signTypeCheckboxLabels'>
                    <div className="SiteTextBox mt-0">
                      <div className="onlyforEnableCheckbox ml-0">
                        <input
                          type="checkbox"
                          className="checkbox_custom"
                          id="cctvService"
                          checked={camerasChecked}
                          onChange={() => setCamerasChecked(!camerasChecked)}
                        />
                        <label className="" htmlFor="cctvService">
                          CCTV
                        </label>
                      </div>
                    </div>
                    <div className="SiteTextBox mt-0">
                      <div className="onlyforEnableCheckbox ml-0">
                        <input
                          type="checkbox"
                          className="checkbox_custom"
                          id="alertsService"
                          checked={alertsChecked}
                          onChange={() => setAlertChecked(!alertsChecked)}

                        />
                        <label className="" htmlFor="alertsService">
                          Alerts
                        </label>
                      </div>
                    </div>
                    <div className="SiteTextBox mt-0">
                      <div className="onlyforEnableCheckbox ml-0">
                        <input
                          type="checkbox"
                          className="checkbox_custom"
                          id="healthService"
                          checked={healthMonitoringChecked}
                          onChange={() => setHealthMonitoringChecked(!healthMonitoringChecked)}
                        />
                        <label className="" htmlFor="healthService">
                          Health Monitoring
                        </label>
                      </div>
                    </div>
                    <div className="SiteTextBox mt-0">
                      <div className="onlyforEnableCheckbox ml-0">
                        <input
                          type="checkbox"
                          className="checkbox_custom"
                          id="backupService"
                          checked={videoBackupChecked}

                          onChange={() => setVideoBackupChecked(!videoBackupChecked)}
                        />
                        <label className="" htmlFor="backupService">
                          Video Backup
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          </>
          )}
          {
            selectedDevice.ParentCameraID != 0
              ?
              <>
                <div className="ACSCustomerFilterMainDiv w40dot75rem mt35">
                  <div className="ACSTextBox mt-0">
                    <p className="SiteNameText mb-0" style={{ fontSize: "1.2rem" }}>
                      Associate Device
                    </p>
                    <div className='filterinnerboxdiv1'>
                      <div>
                        <div className="SelectionListWithSelectAll">
                          <input
                            className="SearchViewInput1"
                            style={{ width: "100%" }}
                            type="search"
                            placeholder="Search"
                            value={cameraSearch}
                            onChange={(e) => searchCCTVCameraHandler(e, "Camera")}
                          />
                        </div>
                      </div>
                      <div className='HgtFilterBoxList' style={{ textAlign: "left", marginLeft: "5px", height: "17vh" }}>
                        {
                          cctvList.length > 0
                            ?
                            cctvList.map((item) => (
                              <div key={item.deviceId} className="dataAccessListItem">
                                <input type="checkbox" checked={item.isChecked} disabled={!editAssociate} onChange={(e) => cctvCheckHandler(e, item.deviceId)} />
                                <p className="AllTextwithValue" disabled={!editAssociate} onClick={(e) => {
                                  if (editAssociate) {
                                    cctvCheckHandler(e, item.deviceId)
                                  }
                                }}>{item.cameraName}</p>
                              </div>
                            ))
                            :
                            <p className="AllTextwithValue" >No Cameras Found</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ alignItems: "center" }}>
                  {
                    !editAssociate
                      ?
                      <button className="DataAccessEdit" style={{ width: "170px" }} onClick={() => setEditAssociate(true)}>
                        <span className="ViewUpdate">Edit Associated Devices</span>
                      </button>
                      :
                      <>
                        <button className="DataAccessEdit" style={{ width: "180px" }} onClick={() => associatetCCTV(selectedDevice)}>
                          <span className="ViewUpdate">Save Associated Devices</span>
                        </button>
                        <button className="DataAccessEdit" style={{ width: "190px" }} onClick={cancelCCTVAssociation}>
                          <span className="ViewUpdate">Cancel Associated Devices</span>
                        </button>
                      </>
                  }
                </div>
              </>
              :
              null
          }
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <button className="DataAccessEdit" style={{ width: "100px" }}
          onClick={handleSubmit((e) => {
            OnSaveDevice(e, selectedDevice.ParentCameraID);
          })}
        >
          <span className="ViewUpdate">Save</span>
        </button>
        <button className="DataAccessEdit" style={{ width: "100px", marginLeft: "10px" }} onClick={onCancel}>
          <span className="ViewUpdate">Cancel</span>
        </button>
      </div>      
    </>
  );
};

export default CCTVDeviceForm;
